<template>
  <div>
    <span :id="name + '-label'" :class="labelSpanCustomClass">{{ label }}</span>
    <div>
      <InlineMessage
        v-if="warningMessage"
        icon="pi-lock"
        class="bg-warning-100 italic leading-4"
        :pt="{ text : 'text-xl leading-6 font-semibold rounded-lg' }"
        severity="warn">
        <template #icon>
          <span class="material-icons-outlined bg-white my-4 mx-2 p-2 rounded-full">lock</span>
        </template>
        {{ warningMessage }}
      </InlineMessage>
    </div>
    <textarea
      v-model="textarea"
      :aria-labelledby="name + '-label'"
      :maxlength="maxLength"
      rows="4"
      :name="name"
      class="form-input min-h-10 mt-2 block w-full"
      :class="{
        'bg-error-100': validationErrors.$error,
      }"
      :disabled="disabled"
      @blur="validationErrors?.$touch"
    />
    <span v-if="maxLength" class="grid grid-cols-2">
      <span
        class="justify-end col-start-2 text-sm text-right text-gray-600"
        :class="
          charCount === parseInt(maxLength) ? 'success text-success-900' : ''
        "
        >{{ charCount }}/{{ maxLength }}</span
      >
    </span>
    <span v-for="(value, rule) in sortedValidationRules" :key="rule">
      <span
        v-if="validationErrors[rule].$invalid"
        :data-cy="name + '-validation'"
        class="error text-error-900"
        :class="[customErrorClass, { hidden: !validationErrors.$error }]"
      >
        <p v-if="rule === 'maxLength'">
          {{ validationMessage[rule] + " " + maxLength }}
        </p>
        <p v-else>{{ validationMessage[rule] }}</p>
      </span>
    </span>
  </div>
</template>

<script>
import InlineMessage from "primevue/inlinemessage";
import validationMessages from "../../../mixins/validationMessages";
export default {
  mixins: [validationMessages],
  components: {InlineMessage},
  props: {
    name: {
      type: String,
      default: "",
    },
    maxLength: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    ariaLabel: {
      type: String,
      default: "",
    },
    typedText: {
      type: String,
      default: "",
    },
    customErrorClass: {
      type: String,
      default: "",
    },
    labelSpanCustomClass: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    warningMessage: {
      type: String,
      required: false,
    }
  },
  emits: ["textUpdate"],
  data() {
    return {
      textarea: "",
    };
  },
  computed: {
    charCount() {
      return this.textarea.length;
    },
  },
  watch: {
    textarea: function (newVal) {
      this.$emit("textUpdate", newVal);
    },
    typedText: function (newVal) {
      if (newVal) this.textarea = newVal;
    },
  },
  created() {
    if (this.typedText) {
      this.textarea = this.typedText.trim();
    }
  },
  methods: {
    clear() {
      this.textarea = "";
    },
  },
};
</script>
